/* global gsap */
import { useRef, useEffect } from 'react';

export function useOpacityScroll<T extends Element = HTMLElement>(delta = 0.3) {
  const ref = useRef<T>(null);

  useEffect(() => {
    function onScroll() {
      const opacity =
        (window.innerHeight - window.scrollY / delta) / window.innerHeight;

      if (opacity >= 0) {
        gsap.set(ref.current, { opacity });
      } else {
        gsap.set(ref.current, { opacity: 0 });
      }
    }

    window.addEventListener('scroll', onScroll);
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return ref;
}

export default {
  useOpacityScroll,
};
